<template>
  <transition name="modal">
    <div class="modal-mask" v-show="show">
      <div class="modal-container">
        <div class="modal-header">
          <h3>Bloquear Atendimentos por Período</h3>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <label>Filtros:</label>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <select-procedimento-contrato
                  :semAgrupados="1"
                  :contrato-id="$route.params.distribuicaoContratoId"
                  placeholder="PROCEDIMENTO"
                  @setProcedimentoSelecionado="(procedimentoSelecionado)=>{setProcedimentoSelecionado(procedimentoSelecionado)}"
                ></select-procedimento-contrato>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <select-profissional
                  placeholder="PROFISSIONAL"
                  @setProfissionalSelecionado="(profissionalSelecionado)=>{setProfissionalSelecionado(profissionalSelecionado)}"
                ></select-profissional>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <select v-model="filtros.sexo" class="form-control">
                  <option :value="SEXO.AMBOS">AMBOS</option>
                  <option :value="SEXO.MASCULINO">MASCULINO</option>
                  <option :value="SEXO.FEMININO">FEMININO</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div :class="{'form-group': true, 'has-error':errors.has('periodo_de') }">
                <label>Período (De)</label>
                <input
                  v-model="filtros.data_inicial"
                  class="form-control"
                  type="date"
                  placeholder="PERÍODO DE"
                  v-validate="'required'"
                  name="periodo_de"
                  ref="periodo_de"
                >
                <span
                  v-show="errors.has('periodo_de')"
                  class="help-block"
                >{{ errors.first('periodo_de') }}</span>
              </div>
            </div>

            <div class="col-md-6">
              <div :class="{'form-group': true, 'has-error':errors.has('periodo_ate') }">
                <label>Período (Até)</label>
                <input
                  v-model="filtros.data_final"
                  class="form-control"
                  type="date"
                  placeholder="PERÍODO DE"
                  v-validate="'required'"
                  name="periodo_ate"
                  ref="periodo_ate"
                >
                <span
                  v-show="errors.has('periodo_ate')"
                  class="help-block"
                >{{ errors.first('periodo_ate') }}</span>
              </div>
            </div>
            <div class="col-md-4">
              <div :class="{'form-group': true, 'has-error':errors.has('atendimento') }">
                <label for>Quantidade de ATENDIMENTOS a bloquear em cada ocorrência</label>
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  v-model.number="dados.quantidade_primeira_bloqueada"
                  v-validate="(dados.quantidade_retorno_bloqueada === '') && (dados.quantidade_local_bloqueada === '') ?'required' : ''"
                  name="atendimento"
                  ref="atendimento"
                >
                <span
                  v-show="errors.has('atendimento')"
                  class="help-block"
                >Defina ao menos um bloqueio</span>
              </div>
            </div>
            <div class="col-md-4">
              <div :class="{'form-group': true, 'has-error':errors.has('retorno') }">
                <label for>Quantidade de RETORNOS a bloquear em cada ocorrência</label>
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  v-model.number="dados.quantidade_retorno_bloqueada"
                  v-validate="(dados.quantidade_primeira_bloqueada === '') && (dados.quantidade_local_bloqueada === '') ?'required' : ''"
                  name="retorno"
                  ref="retorno"
                >
                <span v-show="errors.has('retorno')" class="help-block">Defina ao menos um bloqueio</span>
              </div>
            </div>
            <div class="col-md-4">
              <div :class="{'form-group': true, 'has-error':errors.has('local') }">
                <label for>Quantidade de atendimentos LOCAIS a bloquear em cada ocorrência</label>
                <input
                  type="number"
                  min="0"
                  class="form-control"
                  v-model.number="dados.quantidade_local_bloqueada"
                  v-validate="(dados.quantidade_primeira_bloqueada === '') && (dados.quantidade_retorno_bloqueada === '') ?'required' : ''"
                  name="local"
                  ref="local"
                >
                <span v-show="errors.has('local')" class="help-block">Defina ao menos um bloqueio</span>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 15px; margin-bottom: 15px;">
            <div class="col-sm-12">
              <button @click="getOcorrencias" class="btn btn-warning"><i class="fa fa-refresh"></i> Calcular número total de ocorrências e bloqueios</button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <p>
                Total de registros encontrados no período:
                <strong>{{ ocorrencias.registros }}</strong>
              </p>
              <p>
                Total de atendimentos que serão bloqueados no período:
                <strong>{{ ocorrencias.atendimentos }}</strong>
              </p>
              <p>
                Total de retornos que serão bloqueados no período:
                <strong>{{ ocorrencias.retornos }}</strong>
              </p>
              <p>
                Total de atendimentos locais que serão bloqueados no período:
                <strong>{{ ocorrencias.locais }}</strong>
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-md-12">
              <button @click="salvar()" class="btn btn-primary pull-right" type="button">
                <i class="fa fa-save"></i> Confirmar
              </button>
              <button tag="a" @click="$emit('close')" class="btn btn-default pull-left">
                <i class="fa fa-close"></i> Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import { SEXO } from "@/constants";
import selectProcedimentoContrato from "../contratos/selectDistribuicaoProcedimentosContrato";
import selectProfissional from "../../cadastros/profissionais/selectProfissional";

export default {
  filters: {},
  computed: {
    SEXO: function() {
      return SEXO;
    }
  },
  props: ["show", "distribuicao_contrato_id"],
  data: () => ({
    ocorrencias: {
      registros: 0,
      atendimentos: 0,
      retornos: 0,
      locais: 0,

    },
    filtros: {
			distribuicao_contrato_id: null,
      nome_profissional: "",
      nome_procedimento: "",
      sexo: SEXO.AMBOS,
      tipo: 1,
      coluna: null,
      ordem: null,
      data_inicial: null,
      data_final: null
    },
    dataTable: {},
    bloqueados: {
      primeira: 0,
      retorno: 0,
      local: 0
    },
    dados: {
      quantidade_primeira_bloqueada: "",
      quantidade_retorno_bloqueada: "",
      quantidade_local_bloqueada: ""
    }
  }),
  mounted() {
    document.body.addEventListener("keyup", e => {
      if (e.keyCode === 27) {
        this.$emit("close");
      }
    });
  },
  methods: {
    salvar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          console.log("teste");
          this.$store.commit("TOGGLE_LOADING");
          let config = this.$store.getters.getHeaderAuth;
          this.dados.filtros = this.filtros;
          axios
            .post(
              `${
                this.$store.state.serverURI
              }/api/distribuicao/agenda/bloquearPeriodo`,
              this.dados,
              config
            )
            .then(response => {
              this.$emit("atualizar");
              this.$emit("close");
              this.$store.commit("TOGGLE_LOADING");
            })
            .catch(error => {
              this.$store.commit("throwException", error);
            });
        }
      });
    },
    setProcedimentoSelecionado(procedimentoSelecionado) {
      this.filtros.nome_procedimento =
        procedimentoSelecionado.procedimento.nome;
    },
    setProfissionalSelecionado(profissionalSelecionado) {
      this.filtros.nome_profissional = profissionalSelecionado.nome;
    },
    getOcorrencias() {
				this.filtros.distribuicao_contrato_id = this.$route.params.distribuicaoContratoId;
				this.$store.commit("TOGGLE_LOADING");
				let config = this.$store.getters.getHeaderAuth;
				config.params = this.filtros;
				axios.get(
					`${this.$store.state.serverURI}/api/distribuicao/agenda/getCountProcedimentoAtendimentos`,
					config
				).then(response => {
          let ocorrencias = response.data;
          let atendimentos = ocorrencias * this.dados.quantidade_primeira_bloqueada;
          let retornos = ocorrencias * this.dados.quantidade_retorno_bloqueada;
          let locais = ocorrencias * this.dados.quantidade_local_bloqueada;

          this.ocorrencias.registros = ocorrencias;
          this.ocorrencias.atendimentos = atendimentos;
          this.ocorrencias.retornos = retornos;
          this.ocorrencias.locais = locais;

					this.$store.commit("TOGGLE_LOADING");
				}).catch(error => {
					this.$store.commit("throwException", error);
				});
			},
  },
  watch: {
		show: function(value, old) {
			if (value) {
				this.filtros.distribuicao_contrato_id = this.distribuicao_contrato_id;
			}
		}
  },
  components: {
    selectProcedimentoContrato,
    selectProfissional
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// bloquearPeriodoModal.vue?0b447392